module.exports = __webpack_public_path__ + "/images/logo-fr-amazon.3615ccb.png";